import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import {
  NgbAccordionDirective,
  NgbAccordionModule,
} from '@ng-bootstrap/ng-bootstrap';
import { GlobalModalService } from '../../../shared/services/global-modal.service';
import { RouterModule } from '@angular/router';
import { ContainerComponent } from '../../../shared/components/container/container.component';

@Component({
  selector: '[how-to-explain]',
  imports: [
    NgbAccordionModule,
    ContainerComponent,
    RouterModule,
  ],
  templateUrl: './how-to-explain.html',
  styleUrl: './how-to-explain.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    id: 'faqs',
  }

})
export class HowToExplain {
  private modalService = inject(GlobalModalService);
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('accordions', { static: true }) accordions?: NgbAccordionDirective;
  isAllAccordionsExpanded: boolean = false;

  expandCollapseAllAccordions(): void {
    //expand or collapse depending of current status
    !this.isAllAccordionsExpanded
      ? this.accordions?.expandAll()
      : this.accordions?.collapseAll();

    //toggle variable
    this.isAllAccordionsExpanded = !this.isAllAccordionsExpanded;
    this.cdr.detectChanges();
  }

  navigateTo(url: string, e: Event) {
    e.preventDefault();
    this.modalService.openModal('interstitial', url);
  }
}
